import script from "./ResultadosAutoevaluacionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultadosAutoevaluacionView.vue?vue&type=script&setup=true&lang=ts"

import "./ResultadosAutoevaluacionView.vue?vue&type=style&index=0&id=56ffd0cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ffd0cc"]])

export default __exports__